import { images } from "@/config/images";

export default function Story() {
  return (
    <section id="story" className="bg-background-50 py-14 md:py-20">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          {/* カラフルイラスト画像 */}
          <div className="order-2 lg:order-1 flex justify-center lg:justify-start">
            <div className="w-full max-w-xs md:max-w-sm">
              <div className="aspect-[3/4] rounded-lg overflow-hidden border border-background-200 bg-background-100">
                <img
                  src={images.character}
                  alt="株式会社MEGURI 猪のキャラクターイラスト"
                  className="w-full h-full object-contain"
                />
              </div>
            </div>
          </div>

          {/* 想い */}
          <div className="order-1 lg:order-2">
            <p className="inline-flex items-center gap-2 text-xs md:text-sm font-bold text-accent-700 bg-accent-100 rounded-full px-4 py-1.5 mb-4">
              <i className="ri-heart-line"></i>
              株式会社MEGURIの想い
            </p>
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 leading-snug">
              「猟師さんが捕獲した猪。
              <br />
              どうにか循環させたいと思い、
              <br />
              会社をつくりました。」
            </h2>
            <p className="mt-5 text-sm md:text-base text-foreground-700 leading-relaxed">
              猟師さんから連絡が来ると、必ず私が現地へ向かい、止め刺し・血抜きを行います。
              止め刺しから精肉まで、すべて一人で行っています。
            </p>
            <p className="mt-3 text-sm md:text-base text-foreground-700 leading-relaxed">
              単なるジビエ販売ではなく、命をいただいたからこそ、
              できる限り無駄なく活用し、循環させていく。
              それが株式会社MEGURIの想いです。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}